'use client'

import { useEffect } from 'react'
import { useAppDispatch, useAppSelector, useInjectPageReducer } from '@app/model/store/client'

import ListingReducer, { clearStateListing } from '@pages/Listing/model/slice'
import { selectListingState } from '@pages/Listing/model/selectors'
import { initListingItem, initRestaurantList, setTitleAndDescriptionListingAC } from '@pages/Listing/model/actions'
import { Listing } from '@pages/Listing'
import type { ListingPageClientProps } from '@pages/Listing'

import PageLayout from '@app/PageLayout/PageLayout'

import { BlockBoundary } from '@shared/lib/components/BlockBoundary'

const CURRENT_PAGE = 'rests_listing'

export default function ListingPageClient({
  global_data,
  data,
  seo_read,
  breadcrumbItems,
  initialIntroView,
  children,
}: ListingPageClientProps) {
  useInjectPageReducer('listing', ListingReducer)

  const stateListing = useAppSelector(selectListingState)
  const isGlobalStoreLoaded = useAppSelector((state) => state.global.storeLoaded)
  const isStoreListingLoaded = stateListing.isReady
  const dispatch = useAppDispatch()

  useEffect(() => {
    const { restaurant_list, paramsRequest, afisha_selected } = data
    const results = restaurant_list?.results ?? []
    const pagination = restaurant_list?.pagination ?? null
    const selections = afisha_selected?.results ?? []

    dispatch(initListingItem({ paramsRequest: paramsRequest ?? {}, selections }))
    dispatch(initRestaurantList({ list: results, pagination }))

    return () => {
      dispatch(clearStateListing())
    }
  }, [data, dispatch])

  useEffect(() => {
    if (isGlobalStoreLoaded && isStoreListingLoaded) {
      dispatch(setTitleAndDescriptionListingAC(seo_read?.request ?? '', seo_read?.description ?? ''))
    }
  }, [seo_read, isGlobalStoreLoaded, isStoreListingLoaded, dispatch])

  return (
    <BlockBoundary>
      <PageLayout globalData={global_data} currentPage={CURRENT_PAGE} breadcrumbItems={breadcrumbItems}>
        <Listing
          serverIntro={children}
          initialIntroView={initialIntroView}
          initialList={data.restaurant_list?.results ?? []}
          initialPagination={data.restaurant_list?.pagination ?? null}
          initialSelections={data.afisha_selected?.results ?? []}
        />
      </PageLayout>
    </BlockBoundary>
  )
}
